export default "__VITE_ASSET__66ce4c6e__"